// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__kWqbY","pageContent":"Layout_pageContent__Szzz-"};